import React, { Component } from "react";
import Header from "../components/Header";

export default class NotFound extends Component {
  render() {
    return (
      <div>
        <Header />
        <p className="has-text-centered" style={{ marginTop: "50px" }}>
          <strong className="has-text-white">404</strong> We couldn't find this
          page.
        </p>
      </div>
    );
  }
}
